import Dinero from 'dinero.js';

export const COURSE_DATE_FORMAT = 'MMM D, YYYY [at] h:mm A';
export const ANNUAL_PRICE = Dinero({ amount: 17900 });
